import { useState } from 'react';
import MainLayout from '../../layouts/mainLayout';
import './style.scss';
import InputWithLabel from '../../components/inputWithLabel';
import LoginBtn from '../../components/buttons/loginBtn';
import { emailRegex } from '../../utils/data';
import { forgotPassApi } from '../../api/apis/auth';
import { useNavigate } from 'react-router-dom';


const ForgotPassword = () => {

  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const handleChangeInput = (e) => {
    const { name, value } = e?.target ?? {};
    setFormData(prev => ({ ...prev, [name]: value }))
    setErrors(prev => ({ ...prev, [name]: "" }))
  }
  

  const validateInputs = () => {
    const errors = {};
    if (!formData?.email?.trim()) {
      errors.email = 'Please Enter Email'
    } else if (!emailRegex.test(formData?.email)) {
      errors.email = 'Invalid Email'
    }
    return errors;
  }

  const handleClick = async () => {
    const errors = validateInputs();
    if (Object.keys(errors)?.length) {
      setErrors(errors);
      return;
    }
    setLoading(true)
    try {
      const payload = { email: formData?.email };
      const { data } = await forgotPassApi(payload)
      if (data?.status === "success") {
        navigate("/otp-sent", { state: { email: formData?.email } });
      } else {
        setErrors({ submit: data?.message ?? "" })
      }

    } catch (error) {
      console.log(error)
    }
    setLoading(false)
  }


  const onKeyDown = (e) => {
    if (e?.keyCode === 13 && !(loading)) {
      handleClick()
    }
  }


  return (
    <MainLayout>
      <div className='login__section'>
        <h3>
          Forgot Password
        </h3>
        <br />
        <p className='welcome__description'>
          The Flex Workspace’s Industry First-Ever Quality Standardization
        </p>
        <div className='input__section'>
          <InputWithLabel error={errors?.email} onKeyDown={onKeyDown} classes={"mt-4"} value={formData?.password} label={"Email"} requried={true} name={"email"} onChange={handleChangeInput} placeholder={"email@email.com"} />
          <LoginBtn onClick={handleClick} disabled={loading} loading={loading} text={"Send"} />
          {errors?.submit ? <p className='error__message'>{errors?.submit}</p> : ""}
        </div>
      </div>
    </MainLayout>
  )
}

export default ForgotPassword;